<template>
  <div class="text-gray-600 partnerClass">
    <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-6 md:px-8 lg:px-10 lg:py-10">
      <div class="flex justify-center items-center pt-10">
        <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
        <p class="w-40 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest">合作伙伴</p>
        <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
      </div>

      <!--  临床服务  -->
      <div class="flex justify-center items-center mt-8">
        <p class="w-32 h-9 text-center text-sm leading-9 text-lg font-bold tracking-widest">临床服务</p>
      </div>
      <div class="grid gap-4 mx-auto sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 py-10 justify-items-center">
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.artemed.de/')">
            <img class="absolute object-cover w-full h-full rounded" :src="baseOSSUrl + '/artemed.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">德国阿特迈德医疗集团</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.fresenius.com/')">
            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/fsys.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">德国费森尤斯集团</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer"
            @click="toOutAddresss('https://www.clinicbarcelona.org/en')">
            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/bslndxyy.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">西班牙巴塞罗那大学医院</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.baycrest.org/')">
            <img class="absolute object-cover w-full h-full " :src="baseOSSUrl + '/blstyl.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">加拿大贝莱斯特医疗集团</p>
          </div>
        </div>
        <!-- <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.vamed.com/en/')">
            <img class="absolute object-cover w-full h-full rounded" :src="baseOSSUrl + '/adlamd.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">奥地利奥美德</p>
          </div>
        </div> -->
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.quironsalud.es/')">
            <img class="absolute object-cover w-full h-full " :src="baseOSSUrl + '/qasld.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">西班牙齐昂萨鲁德医疗</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.uwmedicine.org/')">
            <img class="absolute object-cover w-full h-full " :src="baseOSSUrl + '/hsdyy.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">美国华盛顿大学医学中心</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer"
            @click="toOutAddresss('https://www.methodisthealth.org/')">
            <img class="absolute object-cover w-full h-full " :src="baseOSSUrl + '/msds.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">美国美圣迪斯医疗集团</p>
          </div>
        </div>
      </div>

      <!--  在线教育  -->
      <div class="flex justify-center items-center">
        <p class="w-32 h-9 text-center text-sm leading-9 text-lg font-bold tracking-widest">在线教育</p>
      </div>
      <div class="grid gap-4 mx-auto sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 py-10 justify-items-center">
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.cintana.com')">
            <img class="absolute object-cover w-full h-full rounded" :src="baseOSSUrl + '/stnjy.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">圣塔纳教育</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.cognos-ag.de')">
            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/kgnsjy.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">德国科格努斯教育集团</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.fuu.de')">
            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/hdbfy.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">德国海德堡赋优教育集团</p>
          </div>
        </div>
        <!--        <div>-->
        <!--          <div class="relative shadow w-56 h-24 ">-->
        <!--            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/lectur.png" alt="" />-->
        <!--          </div>-->
        <!--          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">-->
        <!--            <p class="text-gray-800 h-7 w-56 text-center titleClass border">德国Lecturio数字在线医学教育</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div>-->
        <!--          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://bau-bildung.de')">-->
        <!--            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/sks.png" alt="" />-->
        <!--          </div>-->
        <!--          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">-->
        <!--            <p class="text-gray-800 h-7 w-56 text-center titleClass border">德国萨克森建筑教育协会</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.hs-fresenius.com')">
            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/fsysyydx.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">德国费森尤斯应用技术大学</p>
          </div>
        </div>
        <!--        <div>-->
        <!--          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.fh-dresden.eu')">-->
        <!--            <img class="absolute object-cover w-full h-full " :src="baseOSSUrl + '/dlsd.png" alt="" />-->
        <!--          </div>-->
        <!--          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">-->
        <!--            <p class="text-gray-800 h-7 w-56 text-center titleClass border">德国德累斯顿应用技术大学</p>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <!--  科学研究  -->
      <div class="flex justify-center items-center">
        <p class="w-32 h-9 text-center text-sm leading-9 text-lg font-bold tracking-widest">科学研究</p>
      </div>
      <div class="grid gap-4 mx-auto sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 py-10 justify-items-center">
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer"
            @click="toOutAddresss('https://www.clinicbarcelona.org/en')">
            <img class="absolute object-cover w-full h-full rounded" :src="baseOSSUrl + '/bslndxyy.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">西班牙巴塞罗那大学医院</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer"
            @click="toOutAddresss('https://www.pumch.cn/index.html')">
            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/bjxhyy.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">北京协和医院</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://stjohns.co.uk/')">
            <img class="absolute object-cover" :src="baseOSSUrl + '/jqdx.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">剑桥大学圣约翰创新中心</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('http://www.gw-icc.com/')">
            <img class="absolute object-cover w-full h-full " :src="baseOSSUrl + '/ccgj.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">长城国际心脏病学会议</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('http://www.pgaorta.com/')">
            <img class="absolute object-cover w-full h-full " :src="baseOSSUrl + '/pgdxg.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center w-56 titleDivBgClass">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">盘古大血管疾病论坛</p>
          </div>
        </div>
      </div>

      <!--  其他合作  -->
      <div class="flex justify-center items-center">
        <p class="w-32 h-9 text-center text-sm leading-9 text-lg font-bold tracking-widest">其他合作</p>
      </div>
      <div class="grid gap-4 mx-auto sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 py-10 justify-items-center">
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://www.ge.com/')">
            <img class="absolute object-cover w-full h-full " :src="baseOSSUrl + '/ge.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center titleDivBgClass h-7 w-56">
            <p class="text-gray-800 h-7 text-center titleClass border">通用电气</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('https://new.siemens.com')">
            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/xmz.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center titleDivBgClass h-7 w-56">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">西门子</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer" @click="toOutAddresss('http://atlatl.cn/')">
            <img class="absolute object-cover w-full h-full" :src="baseOSSUrl + '/fbjsq.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center titleDivBgClass h-7 w-56">
            <p class="text-gray-800 h-7 w-56 text-center titleClass border">飞镖加速器</p>
          </div>
        </div>
        <div>
          <div class="relative shadow w-56 h-24 cursor-pointer"
            @click="toOutAddresss('https://www.bostonscientific.com/')">
            <img class="absolute object-cover w-full h-full rounded" :src="baseOSSUrl + '/bsdkx.png'" alt="" />
          </div>
          <div class="flex flex-col sm:text-center titleDivBgClass h-7 w-56">
            <p class="text-gray-800 h-7 w-56 text-center titleClass">波士顿科学</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  baseOSSUrl
} from '@/utils/oss';
export default {
  name: "homePartner",
  data() {
    return {
      baseOSSUrl
    }
  },
  methods: {
    toOutAddresss(value) {
      window.open(value, '_blank');
    }
  }
}
</script>

<style scoped>
.partnerClass {
  background: linear-gradient(360deg, #FFFFFF 0%, #EFF3FB 100%) !important;
}

.titleDivBgClass {
  background-color: #F3F6FC;
}

.titleClass {
  font-size: 0.875rem;
  line-height: 1.75rem;
}
</style>